<template>
  <div>
    <el-card style="height: 300px">
      <h4>{{land.name}}</h4>
      <el-divider></el-divider>
      <div style="margin: 10px 0" class="title-font">环境监控</div>
      <div v-if="!weatherEditor" style="display: flex;justify-content: space-between;padding: 6px">
        <span style="padding-top: 1px" class="content-font">{{equipSn.weatherSn | weatherSnFormat }}</span>
        <el-button v-if="equipSn.weatherSn==''" type="primary" size="mini" @click="weatherSet">设置</el-button>
        <el-button v-else type="primary" size="mini" @click="weatherUpdate">修改</el-button>
      </div>
      <div v-else style="display: flex;justify-content: space-between">
        <el-input type="mini" v-model="weatherSn"></el-input>
        <div style="width: 120px;padding: 5px">
          <el-button type="primary" size="mini" circle icon="el-icon-check" @click="weatherSure"></el-button>
          <el-button type="warning" size="mini" circle icon="el-icon-close" @click="weatherCancel"></el-button>
        </div>
      </div>
      <div style="margin: 10px 0" class="title-font">智能水肥</div>
      <div v-if="!irrigationEditor" style="display: flex;justify-content: space-between;padding: 6px">
        <div>
          <div style="padding-top: 1px" class="content-font">{{equipSn.irrigationSn | weatherSnFormat }}</div>
          <div v-if="equipSn.irrigatRoute!=''" class="content-font">第{{equipSn.irrigatRoute}}路</div>
        </div>
        <el-button v-if="equipSn.irrigationSn==''" type="primary" size="mini" @click="irrigatSet">设置</el-button>
        <el-button v-else type="primary" size="mini" @click="irrigatUpdate">修改</el-button>
      </div>
      <div v-else style="display: flex;justify-content: space-between;padding: 6px">
        <div>
          <div class="content-font">{{irrigationSnOfland}}</div>
          <div>
            <el-input-number style="width: 70%" v-model="irrigatRoute" :min="1" :max="10" size="mini"></el-input-number>
          </div>
        </div>
        <div style="width: 125px;padding: 5px">
          <el-button type="primary" size="mini" circle icon="el-icon-check" @click="irrigatSure"></el-button>
          <el-button type="warning" size="mini" circle icon="el-icon-close" @click="irrigatCancel"></el-button>
        </div>
      </div>
      <div>
        <el-button v-if="cameras.length==0" type="text" size="mini" @click="setCamera">配置摄像头</el-button>
        <div v-else>(已配置摄像头)</div>
      </div>
    </el-card>
    <camera ref="camera" :landId="land.id" @cameraGet="cameraGet"></camera>
  </div>
</template>

<script>
  import { getDeviceInfoByLand,setDeviceInfoByLand,updateInfoByland,getCamera} from '@/api/equip.js'
  import Camera from "./Camera";
export default {
  name: 'EquipCard',
  components: {Camera},
  props: {
    land: {
      type: Object,
      required: true
    },
    irrigationSnOfland:{
      type: String,
    },
  },
  watch:{
    'land.id':function (val) {
      console.log(val)
      this.getDeviceInfo()
    }
  },
  data() {
    return {
      isHighlight: false,
      editing: false,
      equipSn:{
        irrId:undefined,
        irrigationSn:'',
        irrigatRoute:'',
        weatherId:undefined,
        weatherSn:''
      },
      weatherEditor:false,
      irrigationEditor:false,
      weatherNewSet:false,
      irrigationSnSet:false,
      irrigationSn:'',
      irrigatRoute:'',
      weatherSn:'',
      cameras:[]
    }
  },
  filters:{
    weatherSnFormat(val) {
      if(val=="") {
        return '未设置'
      }else{
        return  val
      }
    }
  },
  methods: {
    setCamera() {
      this.$refs.camera.dialogTableVisible=true
    },
    cameraGet() {
      getCamera(this.land.id).then(data=>{
        console.log(data)
        this.cameras=data.data
      })
    },
    weatherUpdate() {
      this.weatherNewSet=false
      this.weatherEditor=true
      this.weatherSn=this.equipSn.weatherSn
    },
    getDeviceInfo() {
      getDeviceInfoByLand(this.land.id).then(data=>{
        if(data.data.length===0){
          this.equipSn.irrigationSn=""
          this.equipSn.weatherSn=""
          this.equipSn.irrigatRoute=''
          return
        }
        let irrigateObj=data.data.find(item=>item.model=='irrigate')
        let house=data.data.find(item=>item.model=='monitor')
        console.log(irrigateObj)
        if(irrigateObj) {
          this.irrigationSn=irrigateObj.sn
          this.equipSn.irrigationSn=irrigateObj.sn
          this.equipSn.irrId=irrigateObj.id
          this.equipSn.irrigatRoute=irrigateObj.route
        }else{
          this.equipSn.irrigationSn=''
          this.equipSn.irrigatRoute=''
        }
        if(house) {
          this.equipSn.weatherSn=house.sn
          this.weatherSn=house.sn
          this.equipSn.weatherId=house.id
        }else{
          this.equipSn.weatherSn=""
        }
        console.log(data)
      })
    },
    editor(id,parkId) {
      this.$router.push({
        path:'./equip-editor',
        query:{
          id:id,
          parkId:parkId
        }
      })
    },
    weatherSet() {
      console.log('环境')
      this.weatherEditor=true
      this.weatherNewSet=true
      this.weatherSn=this.equipSn.weatherSn
    },
    weatherSure() {
      let option={}
      option.model='monitor'
      option.landId=this.land.id
      option.sn=this.weatherSn
      option.id= this.equipSn.weatherId
      if(this.weatherNewSet){
        this.weatherEditor=false
        setDeviceInfoByLand(option).then(data=>{
          this.getDeviceInfo()
        })
      }else{
        this.weatherEditor=false
        updateInfoByland(option).then(data=>{
          this.getDeviceInfo()
        })
      }

    },
    weatherCancel() {
      this.weatherEditor=false
    },
    irrigatSet() {
      console.log('水肥')
      if(this.irrigationSnOfland==''){
        this.$message.error('该园区没有设置水肥机编号')
        return
      }
      this.irrigationEditor=true
      this.irrigationSnSet=true
      this.irrigatRoute=this.equipSn.irrigatRoute
    },
    irrigatUpdate() {
      this.irrigationEditor=true
      this.irrigationSnSet=false
      this.irrigationSn=this.equipSn.irrigationSn
      this.irrigatRoute=this.equipSn.irrigatRoute
    },
    irrigatSure() {
      let option={}
      option.model='irrigate'
      option.landId=this.land.id
      option.sn=this.irrigationSnOfland
      option.id= this.equipSn.irrId
      option.route=this.irrigatRoute
      if(this.irrigationSnSet){
        this.irrigationEditor=false
        setDeviceInfoByLand(option).then(data=>{
          this.getDeviceInfo()
        })
      }else{
        this.irrigationEditor=false
        updateInfoByland(option).then(data=>{
          this.getDeviceInfo()
        })
      }
    },
    irrigatCancel() {
      this.irrigationEditor=false
    }
  },
  mounted() {
    console.log(this.land)
    this.getDeviceInfo()
    this.cameraGet()
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  }
}
</script>
<style scoped>
.equip {
  height: 120px;
  border: solid 1px #ddd;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
  padding: 5px;
  border-top-width: 8px;
}
.equip.highlight {
  background-color: #f9f9f9;
}
/* .equip.online { */
  /* border-top-color: chartreuse; */
/* } */
.equip h4 {
  font-size: 14px;
  line-height: 28px;
  margin: 0;
  padding: 0;
}
.equip ul {
  padding-left: 6px;
  margin: 6px 0;
  color: #9f9f9f;
}
.equip li {
  font-size: 13px;
  list-style-type: none;
}
.title-font{
  font-size: 14px;
}
.content-font{
  font-size: 13px;
  color: #6f6f6f;
}
</style>



// WEBPACK FOOTER //
// src/components/resource/equip/EquipCard.vue